// extracted by mini-css-extract-plugin
export default {"root":"PaginationHelper_root__Mp38S"};